module.exports = __webpack_public_path__ + "static/media/clothing-1.fdb6b991.svg";